
<script>
import QRCode from 'qrcode'
import LoadingState from '../../../../../components/widgets/LoadingState.vue'

export default {
  name: 'QRGenerator',
  components: {
    LoadingState,
  },
  props: {
    qrValue: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      qrCodeImage: '',
    }
  },
  watch: {
    qrValue: {
      immediate: true,
      handler(newVal) {
        this.generateQRCode(newVal)
      }
    }
  },
  methods: {
    async generateQRCode(value) {
      if (!value) return
      try {
        const dataUrl = await QRCode.toDataURL(value.trim())
        this.qrCodeImage = dataUrl
      } catch (err) {
        console.error('QR Code generation failed', err)
      }
    }
  }
}
</script>

<template>
  <div>
    <div v-if="qrCodeImage">
      <img :src="qrCodeImage" alt="QR Code" class="qr-code-image" />
    </div>
    <div
      v-else
      class="flex items-center justify-center h-64 bg-slate-100 dark:bg-slate-800 rounded-lg"
      >
      <LoadingState />
      <p class="ml-3 text-slate-600 dark:text-slate-400">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.QR_CODE.GENERATING') }}
      </p>
      </div>
  </div>
</template>

<style scoped>
.qr-code-image {
  width: 200px;
  height: 200px;
  border: 2px solid #ccc;
  border-radius: 8px;
}
</style>
